export default defineNuxtPlugin(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/cache-sw.js', {
        scope: '/',
      })
      .then((registration) => {
        registration && registration.update()
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error)
      })
  }
})
